import { render, staticRenderFns } from "./DataTableCalles.vue?vue&type=template&id=69b87077&"
import script from "./DataTableCalles.vue?vue&type=script&lang=js&"
export * from "./DataTableCalles.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCalles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
